
/**
 * Generate BreadcrumbList schema
 */
export function generateBreadcrumbSchema(breadcrumbs: { name: string, url: string }[]) {
  const domain = 'https://www.grandpal.co'; // Use consistent domain across the site
  
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name, // Ensure name is included
      "item": item.url.startsWith('http') ? item.url : `${domain}${item.url}` // Ensure item is a full URL
    }))
  };
}
